var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('button',{on:{"click":_vm.addNode}},[_vm._v("新增一级类目")]),_c('vue-tree-list',{attrs:{"model":_vm.data,"default-tree-node-name":"new node","default-leaf-node-name":"new leaf","default-expanded":true},on:{"click":_vm.onClick,"change-name":_vm.onChangeName,"delete-node":_vm.onDel,"add-node":_vm.onAddNode}})],1),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }